import React, { useCallback, useMemo } from 'react';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import useTranslations from '../../hooks/useTranslations';
import EmptyHeight from '../EmptyHeight';
import { DICTIONARY } from '../../translations/dictionary';
import { resourcePathAtom, siteModulesAtom } from '../../atoms/globalAtoms';

const sections = [
  { title: '', content: ['section1_1'] },
  { title: 'section2_title', content: ['section2_1', 'section2_3', 'section2_3', 'section2_4'] },
  { title: 'section3_title', content: ['section3_1'] },
  { title: 'section4_title', content: ['section4_1', 'section4_2', 'section4_3', 'section4_4', 'section4_5', 'section4_6', 'section4_7', 'section4_8', 'section4_9'] },
  { title: 'section5_title', content: ['section5_1', 'section5_2', 'section5_3', 'section5_4', 'section5_5'] },
  { title: 'section6_title', content: ['section6_1'] },
  { title: 'section7_title', content: ['section7_1'] },
  { title: 'section8_title', content: ['section8_1'] },
  { title: '', content: ['section9_1'] },
];

function PersonalDataProcessingContent() {
  const { t } = useTranslations();
  const [siteModules] = useAtom(siteModulesAtom);

  const privacyModule = useMemo(() => siteModules?.find((i) => i.module_name === 'privacy'), [siteModules]);

  const renderContent = useCallback(() => {
    if (privacyModule?.content) {
      return <div dangerouslySetInnerHTML={{ __html: privacyModule.content }} />;
    }

    return (
      sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className={styles.section}>
          {section.title && (
          <h6>{t(DICTIONARY.personalDataAgreement[section.title])}</h6>
          )}

          {section.content.map((contentKey, index) => {
            const contentValue = t(DICTIONARY.personalDataAgreement[contentKey]);
            const content = Array.isArray(contentValue)
              ? contentValue.join('')
              : contentValue;

            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            );
          })}
        </div>
      ))
    );
  }, [privacyModule]);

  return (
    <div className={styles.personalDataWrapper}>
      {renderContent()}
    </div>
  );
}

export default PersonalDataProcessingContent;
